import { jsxs, jsx } from 'react/jsx-runtime';
import { IconError, IconCheck } from '@wds/icons';
import { Box } from '@wds/box';
import { createMemoStyles, getColor } from '@wds/styles';
import { defaultBaseline, defaultFonts } from '@wds/utils';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var useStyles = createMemoStyles(function (theme) {
  var spacing = theme.spacing,
    palette = theme.palette,
    type = theme.type;
  return {
    wrenchInputMessage: function () {
      return __assign(__assign(__assign({}, defaultBaseline), defaultFonts(theme)), {
        marginTop: spacing[2],
        color: getColor(palette, 'darkMuted'),
        fontSize: type.fontSize.bodySm,
        fontWeight: type.fontWeight.regular,
        alignItems: 'center',
        display: 'flex'
      });
    }
  };
});

var InputMessage = function InputMessage(_a) {
  var children = _a.children,
    color = _a.color,
    id = _a.id,
    _b = _a.errorTitle,
    errorTitle = _b === void 0 ? 'Error' : _b,
    _c = _a.successTitle,
    successTitle = _c === void 0 ? 'Success' : _c;
  var wrenchInputMessage = useStyles().wrenchInputMessage;
  return jsxs("div", {
    role: "alert",
    className: wrenchInputMessage,
    id: id,
    children: [jsxs(Box, {
      mr: 1,
      display: "inline-flex",
      alignItems: "center",
      children: [color === 'error' && jsx(IconError, {
        color: color,
        title: errorTitle
      }), color === 'success' && jsx(IconCheck, {
        color: color,
        title: successTitle
      })]
    }), children]
  });
};

export { InputMessage };
